// extracted by mini-css-extract-plugin
module.exports = {"field":"TopFiveItem_field__2tr2J","showField":"TopFiveItem_showField__UnZQd"};